import axios from 'axios'
import { SearchUrlParamBuilder } from '@/core/utils'

class AtaApiClient {
	URL_PATH = '/ata-registro-preco/api/public/atas'

	async buscarPorId(idAta) {
		return await axios.get(`${this.URL_PATH}/${idAta}`)
	}

	async buscarAtasPorFiltro(filtro, paginacao) {
		const url = new SearchUrlParamBuilder({
			urlPath: this.URL_PATH,
			filters: filtro,
			pagingAndSorting: paginacao,
		}).buildFiltroPadraoEAvancado()
		return await axios.get(url)
	}

	async baixarDocumentoProcessoDigital(idDocumento) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${this.URL_PATH}/documentos/documentoPublico/${idDocumento}/baixar`,
		}).build()

		return await axios.get(url, {
			responseType: 'arraybuffer',
		})
	}

	async buscarInfoCabecalho(idAta) {
		const { data } = await axios.get(`${this.URL_PATH}/informacoes/${idAta}`)
		return data
	}

	async buscarOrgaosParticipantesDaAta(idAta) {
		return await axios.get(`${this.URL_PATH}/${idAta}/buscarOrgaosParticipantes`)
	}
}

export default new AtaApiClient()
